import * as React from 'react';
import * as Images from 'pos/Images';
import * as UI from 'core/ui';
import { OnlineReservationInListDTO, Res } from 'core/api';
import { DialogIcon } from 'pos/ui';
import { Flex, Cols, Col } from 'core/ui';

export function ReservationDetails({ reservation, showLocation }: { reservation: Nullable<OnlineReservationInListDTO>, showLocation: boolean }) {
	const customerName = reservation
		? reservation.Customer === 'WALK IN'
			? Res.Web.RESERVATION_DETAILS_WALK_IN()
			: reservation.Customer
		: Res.Web.RESERVATION_DETAILS_NO_RESERVATION();

	return <Flex.Vertical>
		<Flex.Item className='border-bottom'>
			<DialogIcon src={Images.OnlineReservation} />

			<ReservationCustomer customer={customerName} />

			{showLocation && reservation
				? <ReservationLocation location={reservation.Location} />
				: null}


			{reservation
				? <ReservationTime startTime={reservation.StartTime} endTime={reservation.EndTime} />
				: null}
		</Flex.Item>

		<Flex.Item size='*'>
			{reservation
				? <ReservationNotes notes={reservation.Notes} />
				: null}
		</Flex.Item>
	</Flex.Vertical>;
}

function ReservationCustomer(props: { customer: string }): React.ReactNode {
	return <Cols>
		<Col width='*' className='text-center m-t-md text-18'>
			{props.customer}
		</Col>
	</Cols>;
}

function ReservationLocation(props: { location: string }): React.ReactNode {
	return <Cols>
		<Col width='*' className='text-center m-t-md'>{Res.Web.RESERVATION_DETAILS_LOCATION_LBL()} <span className='m-l-xs'>{props.location}</span></Col>
	</Cols>;
}

function ReservationTime(props: { startTime: Date, endTime: Date }): React.ReactNode {
	return <Cols>
		<Col>{Res.Web.RESERVATION_DETAILS_START_TIME_LBL()}</Col>
		<Col><span className='m-l-xs'>{UI.Format.asTime(props.startTime)}</span></Col>
		<Col width='*' className='text-right'>{Res.Web.RESERVATION_DETAILS_END_TIME_LBL()}</Col>
		<Col className='text-right'><span className='m-l-xs'>{UI.Format.asTime(props.endTime)}</span></Col>
	</Cols>;
}

function ReservationNotes(props: { notes: string }): React.ReactNode {
	return props.notes.length ?
		<Cols className='m-t'>
			<Col width='*'>
				<p><em>{UI.addLineBreaks(props.notes)}</em></p>
			</Col>
		</Cols> : null;
}
